import { Location } from './location';
import { Rectangle, canContainRectangle } from './rectangle';
export class RectangleLocationError extends Error {
}
export function canEnclose(subject, target) {
    return (subject.getXMin() <= target.getXMin() && subject.getYMin() <= target.getYMin() &&
        subject.getXMax() >= target.getXMax() && subject.getYMax() >= target.getYMax());
}
export function grow(rectangleLocation, units) {
    const grown = rectangleLocation.clone();
    grown.rectangle.setLength(rectangleLocation.getRectangleLength() + 2 * units);
    grown.rectangle.setWidth(rectangleLocation.getRectangleWidth() + 2 * units);
    grown.location.setX(rectangleLocation.location.getX() - units);
    grown.location.setY(rectangleLocation.location.getY() - units);
    return grown;
}
export function copyToLocation(rectangleLocation, x, y) {
    const clone = rectangleLocation.clone();
    clone.location = new Location(x, y);
    return clone;
}
export function getExtremes(boxes) {
    return boxes
        .reduce(([xMin, yMin, xMax, yMax], cv) => [
        Math.min(xMin, cv.getXMin()),
        Math.min(yMin, cv.getYMin()),
        Math.max(xMax, cv.getXMax()),
        Math.max(yMax, cv.getYMax()),
    ], [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY]);
}
export class RectangleLocation {
    constructor(width, length, x, y, rotated) {
        this.rotated = rotated;
        this.rectangle = new Rectangle(width, length);
        this.location = new Location(x, y);
    }
    isRotated() {
        return this.rotated;
    }
    setRotated(rotated) {
        this.rotated = rotated;
    }
    setLocation(x, y) {
        this.location = new Location(x, y);
    }
    getWidth() {
        return this.isRotated() ? this.rectangle.getLength() : this.rectangle.getWidth();
    }
    getLength() {
        return this.isRotated() ? this.rectangle.getWidth() : this.rectangle.getLength();
    }
    getRectangleWidth() {
        return this.rectangle.getWidth();
    }
    getRectangleLength() {
        return this.rectangle.getLength();
    }
    canEnclose(target) {
        return canEnclose(this, target);
    }
    canContain(targetWidth, targetLength) {
        return canContainRectangle(this.rectangle.getWidth(), this.rectangle.getLength(), targetWidth, targetLength);
    }
    ;
    getXMax() {
        return this.location.getX() + this.getWidth() - 1;
    }
    getXMin() {
        return this.location.getX();
    }
    getXCenter() {
        return this.location.getX() + (this.getWidth() / 2);
    }
    getYMax() {
        return this.location.getY() + this.getLength() - 1;
    }
    getYMin() {
        return this.location.getY();
    }
    getYCenter() {
        return this.location.getY() + (this.getLength() / 2);
    }
    copyLeft() {
        return copyToLocation(this, this.location.getX() - this.getWidth(), this.location.getY());
    }
    copyRight() {
        return copyToLocation(this, this.location.getX() + this.getWidth(), this.location.getY());
    }
    copyTop() {
        return copyToLocation(this, this.location.getX(), this.location.getY() + this.getLength());
    }
    copyBottom() {
        return copyToLocation(this, this.location.getX(), this.location.getY() - this.getLength());
    }
    clone() {
        return new RectangleLocation(this.getRectangleWidth(), this.getRectangleLength(), this.location.getX(), this.location.getY(), this.isRotated());
    }
    equalsRectangleLocation(recL2) {
        return this.rectangle.equalsRectangle(recL2.rectangle)
            && this.location.equalsLocation(recL2.location)
            && this.isRotated() === recL2.isRotated();
    }
}
